<app-container>
    <div class="overflow-hidden">
        <div #pageHeader class="w-100 d-flex align-items-end justify-content-between">
            <img src="assets/images/logo.png" alt="" height="144px" width="240px">
            <div class="d-flex flex-column align-items-end justify-content-between gap-4">
                <app-button [label]="'PATIENT_TIMELINE_INFORMATION.CLOSE_SHARING' | translate" icon="close" [fullWidth]="false" (pressed)="closeTimelineSharing()" />
                <div class="d-flex align-items-center gap-2">
                    <app-search-input />
                    <app-button type=outlined [label]="filtersButtonLabel()" [icon]="showFilters() ? 'close' : 'filter'" [fullWidth]="false" (pressed)="closeFilters()" />
                </div>
            </div>
        </div>
        <div #moreFilters [@filtersHeightAnimation]="showFilters().toString()" class="more-filters overflow-hidden row g-2">
            <div class="col-3"></div>
            <div class="col-3">
                <div class="input position-relative select-dropdown d-flex align-items-center justify-content-between gap-2 w-100" (click)="recordTypeSelect.open()">
                    <p class="active-label nunito-semibold">
                        @if (filterParams().type)
                        {
                            {{getTypeLabel(filterParams().type)}}
                        }
                        @else 
                        {
                            {{'PATIENT_TIMELINE_INFORMATION.TYPE' | translate}}
                        }
                    </p>
                    <svg-icon src="assets/icons/chevron-down.svg" class="dropdown-icon d-flex align-items-center" />
                    <mat-select #recordTypeSelect (selectionChange)="typeChanged($event)" class="record-type-select position-absolute invisible w-100 h-100">
                        @for (type of clinicalRecordType; track $index)
                        {
                            <mat-option [value]="type">{{getTypeLabel(type)}}</mat-option>
                        }
                    </mat-select>
                </div>
            </div>
            <div class="col-3">
                <div class="input date-picker position-relative d-flex align-items-center justify-content-between gap-2 w-100" (click)="startDatePicker.open()">
                    <p class="active-label nunito-semibold">
                        @if (filterParams().startDateFilter)
                        {
                            {{filterParams().startDateFilter | date: 'dd/MM/yyyy'}}
                        }
                        @else 
                        {
                            {{'PATIENT_TIMELINE_INFORMATION.START_DATE' | translate}}
                        }
                    </p>
                    <svg-icon src="assets/icons/calendar.svg" class="calendar-icon d-flex align-items-center" />
                    <input class="date-input invisible position-absolute w-100 h-100" matInput [(ngModel)]="filterParams().startDateFilter" (dateChange)="getDetails()" [matDatepicker]="startDatePicker"  />
                </div>
                <mat-datepicker #startDatePicker></mat-datepicker>
            </div>
            <div class="col-3">
                <div class="input date-picker position-relative d-flex align-items-center justify-content-between gap-2 w-100" (click)="endDatePicker.open()">
                    <p class="active-label nunito-semibold">
                        @if (filterParams().endDateFilter)
                        {
                            {{filterParams().endDateFilter | date: 'dd/MM/yyyy'}}
                        }
                        @else 
                        {
                            {{'PATIENT_TIMELINE_INFORMATION.END_DATE' | translate}}
                        }
                    </p>
                    <svg-icon src="assets/icons/calendar.svg" class="calendar-icon d-flex align-items-center" />
                    <input class="date-input invisible position-absolute w-100 h-100" matInput [(ngModel)]="filterParams().endDateFilter" (dateChange)="getDetails()" [matDatepicker]="endDatePicker"  />
                </div>
                <mat-datepicker #endDatePicker></mat-datepicker>
            </div>
        </div>
        <div class="row">
            <div class="col-3 gap-4 d-flex flex-column" [@columnHeightAnimation]="showFilters().toString()">
                <div class="card patient-details w-100 d-flex flex-column gap-3">
                    @if (!!patientDetails())
                    {
                        <img [src]="patientDetails().picture ?? 'assets/images/avatar_placeholder.webp'" alt="" class="patient-picture">
                        @if (patientDetails().firstName || patientDetails().lastName)
                        {
                            <p class="card-information-title nunito-bold">
                                {{patientDetails().firstName ?? ''}} {{patientDetails().lastName ?? ''}}
                            </p>
                        }
                        <ng-container *ngTemplateOutlet="personalInformation; context: {patient: patientDetails()}"></ng-container>
                    }
                    @else
                    {
                        <ng-container *ngTemplateOutlet="loading"></ng-container>
                    }
                </div>
                <div class="card patient-details habits w-100 d-flex flex-column gap-3">
                    @if (!!patientDetails())
                    {
                        <p class="card-information-title nunito-bold">
                            {{'PATIENT_TIMELINE_INFORMATION.PRACTICES' | translate}}
                        </p>
                        <app-habit icon="smoke" [habit]="patientDetails()?.practices?.smoke" />
                        <app-habit icon="drink" [habit]="patientDetails()?.practices?.drink" />
                        <app-habit icon="sports" [habit]="patientDetails()?.practices?.sport" />
                    }
                    @else
                    {
                        <ng-container *ngTemplateOutlet="loading"></ng-container>
                    }
                </div>
            </div>
            <div class="col-9 d-flex flex-column gap-3" [@columnHeightAnimation]="showFilters().toString()">
                <div #timelineCard class="card timeline w-100 d-flex flex-column">
                    @if(!!timelineRecords())
                    {
                        <div class="timeline-header">
                            <h4 class="timeline-title nunito-bold">
                                {{'PATIENT_TIMELINE_INFORMATION.HISTORY' | translate}}
                            </h4>
                        </div>
                        @if (!isFetchingDetails())
                        {
                            <app-timeline [timelineRecords]="timelineRecords()" />
                        }
                        @else
                        {
                            <div class="py-3">
                                <ng-container *ngTemplateOutlet="loading"></ng-container>
                            </div>
                        }
                    }
                    @else 
                    {
                        <ng-container *ngTemplateOutlet="loading"></ng-container>
                    }
                </div>
            </div>
        </div>
    </div>
</app-container>
<ng-template #personalInformation let-patient="patient">
    <div class="d-flex gap-2 flex-wrap">
        @if (patient.age)
        {
            <div class="card-sub-information d-flex gap-1 align-items-center">
                <svg-icon src="assets/icons/calendar.svg" class="information-icon d-flex align-items-center" />
                <p class="card-sub-information nunito-regular">
                    {{patient.age}} {{'PATIENT_TIMELINE_INFORMATION.YEARS_OLD' | translate}}
                </p>
            </div>
        }
        @if (patient.gender)
        {
            <div class="card-sub-information d-flex gap-1 align-items-center">
                <svg-icon src="assets/icons/gender.svg" class="information-icon d-flex align-items-center" />
                <p class="card-sub-information-label nunito-regular">
                    {{getGender()}}
                </p>
            </div>
        }
        @if (patientDetails().weight)
        {
            <div class="card-sub-information d-flex gap-1 align-items-center">
                <svg-icon src="assets/icons/weight.svg" class="information-icon d-flex align-items-center" />
                <p class="card-sub-information-label nunito-regular">
                    {{patient.weight.toFixed(0)}} kg
                </p>
            </div>
        }
        @if (patient.height)
        {
            <div class="card-sub-information d-flex gap-1 align-items-center">
                <svg-icon src="assets/icons/height.svg" class="information-icon d-flex align-items-center" />
                <p class="card-sub-information-label nunito-regular">
                    {{(patient.height / 100).toFixed(2)}} m
                </p>
            </div>
        }
        @if (patient.jobPosition)
        {
            <div class="card-sub-information d-flex gap-1 align-items-center">
                <svg-icon src="assets/icons/job-position.svg" class="information-icon d-flex align-items-center" />
                <p class="card-sub-information-label nunito-regular">
                    {{patient.jobPosition}}
                </p>
            </div>
        }
    </div>
</ng-template>
<ng-template #loading>
    <div class="d-flex align-items-center justify-content-center w-100 h-100">
        <div class="spinner-border main-color" role="status"></div>
    </div>
</ng-template>
